<template>
    <div>
        <ModalStepByStep
            v-if="device !== 'mobile' && !modalTitle.includes('Edit')"
            :modalTitle="modalTitle"
            :isOpen="sidebarVisible"
            :stepPosition="currentStep"
        />
        <b-sidebar
            id="sidebar-right"
            :class="['sidebar-manage-table', modalTitle.includes('Edit') ? 'is-edit' : '']"
            right
            bg-variant="white"
            :width="device === 'desktop' ? '407px' : device === 'tablet' ? '60vw' : '100vw'"
            v-model="sidebarVisible"
        >
            <template #header>
                <div class="header-sidebar">
                    <div class="sidebar-title">
                        {{
                            modalTitle.includes("Edit")
                                ? $t(modalTitle)
                                : $t(getModalTitle(currentStep))
                        }}
                    </div>
                    <span
                        v-if="modalTitle.includes('Edit')"
                        class="close-icon"
                        v-b-toggle.sidebar-right
                    >
                        <CloseIcon />
                    </span>
                </div>

                <div class="separator"></div>
                <div v-if="modalTitle.includes('Edit')">
                    <div class="modal-navbar">
                        <div
                            :class="['info', currentTab === 'info' ? 'active' : '']"
                            @click="currentTab = 'info'"
                        >
                            {{ $t("Informations") }}
                        </div>
                        <div
                            :class="['attachments', currentTab === 'attachments' ? 'active' : '']"
                            @click="currentTab = 'attachments'"
                        >
                            {{ $t("MaterialsPage.Attachments") }}
                        </div>
                    </div>
                </div>
            </template>
            <template>
                <div
                    v-if="currentTab === 'info'"
                    class="infos-tab"
                >
                    <b-col md="12">
                        <b-form-group
                            :label="$t('ResourceStatus.Name')"
                            label-for="name"
                            :invalid-feedback="
                                flagNameEqual ? $t('NameAlreadyExists') : $t('RequiredField')
                            "
                        >
                            <b-form-input
                                id="name"
                                v-model="name"
                                :placeholder="$t('ResourceStatus.Placeholder')"
                                :state="states.name"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col
                        md="12"
                        class="form-group"
                    >
                        <label for="type-select">
                            {{ $t("ResourceStatus.ResourceType") }}
                        </label>
                        <SingleSelect
                            id="type-select"
                            :placeholder="$t('Select')"
                            :optionSelected="typeList.find((item) => item.value == type)"
                            :options="typeList"
                            :searchable="false"
                            :translate="true"
                            :state="states.type"
                            @input="(value) => (type = value ? value.value : value)"
                        >
                            {{ $t("RequiredField") }}
                        </SingleSelect>
                    </b-col>
                    <b-col md="12">
                        <b-form-group
                            :label="$t('ResourceStatus.Code')"
                            label-for="code"
                            :invalid-feedback="
                                flagCodeEqual ? $t('CodeAlreadyExists') : $t('RequiredField')
                            "
                        >
                            <b-form-input
                                id="code"
                                v-model="code"
                                :placeholder="$t('ResourceStatus.Placeholder')"
                                :state="states.code"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group
                            :label="$t('ResourceStatus.ProductionRate')"
                            label-for="productionRate"
                            :invalid-feedback="$t('RequiredField')"
                        >
                            <b-form-input
                                id="productionRate"
                                v-model="productionRate"
                                type="number"
                                step="0.01"
                                :placeholder="$t('ResourceStatus.Placeholder')"
                                :state="states.productionRate"
                                @input.native="decimalMask()"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col
                        md="12"
                        class="form-group appointment"
                    >
                        <div class="w-100">
                            <label for="type-select">
                                {{ $t("ResourceStatus.AppointmentType") }}
                            </label>
                            <SingleSelect
                                id="type-select"
                                :placeholder="$t('Select')"
                                :optionSelected="
                                    appointmentList.find((item) => item.value == appointment)
                                "
                                :options="appointmentList"
                                :searchable="false"
                                :state="states.appointment"
                                @input="(value) => (appointment = value ? value.value : value)"
                            >
                                {{ $t("RequiredField") }}
                            </SingleSelect>
                        </div>
                        <div
                            v-if="appointment === 2"
                            class="w-100 idle-time"
                        >
                            <b-form-group
                                :label="$t('ResourceStatus.IdleTime')"
                                label-for="idleTime"
                                :invalid-feedback="$t('RequiredField')"
                            >
                                <b-form-input
                                    id="idleTime"
                                    v-model="idleTime"
                                    type="number"
                                    step="0.01"
                                    :placeholder="$t('ResourceStatus.TimesPlaceholder')"
                                    :state="states.idleTime"
                                />
                            </b-form-group>
                        </div>
                    </b-col>
                    <div class="toggle-block">
                        <ToggleCard
                            v-model="automaticFinalization"
                            :title="$t('ResourceStatus.AutomaticFinalization')"
                            :tooltip="$t('ResourceStatus.TootlipAuto')"
                        />

                        <ToggleCard
                            v-model="allowMultipleOrders"
                            :title="$t('ResourceStatus.AllowMultipleOrder')"
                            :tooltip="$t('ResourceStatus.TootlipMultipleOrder')"
                        >
                            <div class="order-quantity">
                                <span>{{ $t("ResourceStatus.NumberofOrders") }}</span>
                                <b-form-group>
                                    <b-form-input
                                        id="orderQuantity"
                                        v-model="orderQuantity"
                                        type="number"
                                        min="2"
                                        step="1"
                                        :state="states.orderQuantity"
                                        @blur="onQuantityBlur"
                                        @input.native="
                                            (e) => {
                                                const maskApplied = e.target.value.replace(
                                                    /[^0-9]/g,
                                                    ''
                                                );
                                                number = maskApplied;
                                                e.target.value = maskApplied;
                                            }
                                        "
                                    />
                                </b-form-group>
                            </div>
                        </ToggleCard>
                    </div>

                    <div v-if="customFields.length && forceRenderIndustrialParametersList">
                        <div
                            v-for="field in displayImportantFirst"
                            :key="field.id"
                        >
                            <custom-fields
                                :field="field"
                                :hasError="states.customFieldsForceError"
                                @input="
                                    (value) => {
                                        field.value = value ? value : null;
                                    }
                                "
                            />
                        </div>
                    </div>
                </div>
                <div
                    v-if="currentTab === 'attachments'"
                    class="h-100 links-attachments-tab"
                >
                    <div class="attached-links">
                        {{ $t("MaterialsPage.AttachedURL") }}
                    </div>
                    <div class="links-tab-block h-100">
                        <b-col
                            md="12"
                            class="add-urls-block"
                        >
                            <b-form-group :invalid-feedback="$t('URLAlreadyAttached')">
                                <b-form-input
                                    v-model="newLink"
                                    type="url"
                                    :state="states.newLink"
                                    :placeholder="$t('TypeHere')"
                                    @input="states.newLink = null"
                                />
                            </b-form-group>
                            <b-button
                                class="btn-new-link"
                                variant="primary"
                                @click="addNewLink()"
                            >
                                {{ $t("MaterialsPage.AttachURL") }}
                            </b-button>
                        </b-col>

                        <div
                            v-if="links.length === 0"
                            class="no-links-block"
                        >
                            <div class="no-links">
                                <UrlIcon class="no-url-icon" />
                                <p class="title">{{ $t("MaterialsPage.NoLinkTitle") }}</p>
                            </div>
                        </div>
                        <div
                            v-else
                            class="links-block"
                        >
                            <div
                                v-for="(link, index) in links"
                                :key="link.url + '-' + index"
                                class="attached-link"
                            >
                                <div class="icon-name">
                                    <UrlIcon class="icon" />
                                    <div class="text">{{ link.name || link.url }}</div>
                                </div>
                                <div
                                    class="delete-link"
                                    @click="removeLink(index)"
                                >
                                    <TrashIcon />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="attachments-tab-block h-100">
                        <input
                            type="file"
                            name="editfiles"
                            multiple
                            ref="editfilesResource"
                            style="display: none"
                            @change="handleFileChange"
                        />
                        <div class="attached-files">
                            {{ $t("MaterialsPage.AttachedFiles") }}
                        </div>
                        <b-col md="12">
                            <b-button
                                class="btn-new-attachment"
                                @click="addNewAttachment()"
                            >
                                {{ $t("MaterialsPage.Attachfile") }}
                            </b-button>
                        </b-col>

                        <div
                            v-if="attachments.length === 0"
                            class="no-attachments-block"
                        >
                            <div class="no-attachments">
                                <EmptyBoxIcon class="empty-box" />
                                <p class="title">{{ $t("MaterialsPage.NoAttachmentTitle") }}</p>
                            </div>
                        </div>
                        <div
                            v-else
                            class="files-block"
                        >
                            <div
                                v-for="(file, index) in attachments"
                                :key="file.name + '-' + index"
                                class="attached-file"
                            >
                                <div class="icon-name">
                                    <component
                                        :is="file.icon"
                                        class="icon"
                                    />
                                    <div class="text">{{ file.name }}</div>
                                </div>
                                <div
                                    class="delete-file"
                                    @click="removeFile(index)"
                                >
                                    <TrashIcon />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template #footer>
                <div class="separator"></div>
                <div
                    v-if="device === 'mobile' && !modalTitle.includes('Edit')"
                    class="step-action"
                >
                    <div class="d-flex justify-content-between">
                        <div
                            :class="[
                                'step-collapse',
                                isStepBlockOpenned ? 'not-collapsed' : 'collapsed'
                            ]"
                        >
                            {{ `${currentStep} ${$t("Of")} 2`
                            }}<span
                                id="step-collapse"
                                @click="openStepBlock()"
                                class="icon"
                            >
                                <ArrowDownIcon
                            /></span>
                        </div>
                        <div class="text">{{ $t(getModalTitle(currentStep)) }}</div>
                    </div>
                    <div class="step-progress">
                        <div
                            :class="[
                                'first-step',
                                currentStep === 1
                                    ? 'step-active'
                                    : currentStep > 1
                                      ? 'next-step'
                                      : ''
                            ]"
                        ></div>
                        <div
                            :class="[
                                'second-step',
                                currentStep === 2
                                    ? 'step-active'
                                    : currentStep > 2
                                      ? 'next-step'
                                      : ''
                            ]"
                        ></div>
                    </div>
                    <b-collapse :visible="isStepBlockOpenned">
                        <div class="progress-block">
                            <div class="separator-progress"></div>
                            <div class="detail-block">
                                <div
                                    :class="[
                                        'info-block',
                                        currentStep === 1
                                            ? 'step-active'
                                            : currentStep > 1
                                              ? 'next-step'
                                              : ''
                                    ]"
                                >
                                    <div class="icon"><InfoIcon /></div>
                                    <div class="text">
                                        {{ $t("PeoplePage.GeneralInformation") }}
                                    </div>
                                </div>
                                <div
                                    :class="[
                                        'vertical-separator',
                                        currentStep === 2
                                            ? 'next-step'
                                            : currentStep > 2
                                              ? 'next-step'
                                              : ''
                                    ]"
                                ></div>

                                <div
                                    :class="[
                                        'attachments-block',
                                        currentStep === 2 ? 'step-active' : ''
                                    ]"
                                >
                                    <div class="icon"><AttachmentsIcon /></div>
                                    <div class="text">{{ $t("MaterialsPage.Attachments") }}</div>
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>
                <div class="separator-progress"></div>
                <b-col
                    md="12"
                    class="footer-sidebar"
                >
                    <div class="d-flex buttons">
                        <b-button
                            class="btn btn-cancel btn-footer btn-cancel-outline"
                            v-b-toggle.sidebar-right
                        >
                            {{ $t("RefuseStatus.Cancel") }}
                        </b-button>
                        <b-button
                            v-if="!modalTitle.includes('Edit') && currentStep !== 1"
                            class="btn-previous btn-footer"
                            @click="previousStep()"
                        >
                            {{ $t("PeoplePage.Previous") }}
                        </b-button>
                        <b-button
                            v-if="modalTitle.includes('Edit') || currentStep === 2"
                            class="btn btn-save btn-footer"
                            :disabled="uploadingAttachments"
                            @click="addResource()"
                        >
                            {{ $t("RefuseStatus.Save") }}
                        </b-button>
                        <b-button
                            v-else
                            class="btn btn-save btn-footer"
                            :disabled="uploadingAttachments"
                            @click="nextStep()"
                        >
                            {{ $t("RefuseStatus.Next") }}
                        </b-button>
                    </div>
                </b-col>
            </template>
        </b-sidebar>
        <div id="resources-page">
            <div
                v-if="list.length === 0 && !noItemsFound"
                class="h-100"
            >
                <div class="no-items h-100">
                    <EmptyBoxIcon class="empty-box" />
                    <p class="title">{{ $t("ResourcePage.NoResourcesTitle") }}</p>
                    <p class="subtitle">{{ $t("ResourcePage.NoResourcesSubtitle") }}</p>
                    <b-button
                        class="btn-new-resource"
                        v-b-toggle.sidebar-right
                        @click="changeModalName('new')"
                    >
                        <AddIcon class="add-icon" />
                        {{ $t("ResourcePage.NewFeature") }}
                    </b-button>
                </div>
            </div>
            <div v-else>
                <div class="header-block">
                    <div class="title">
                        {{ $t("PagesViews.Resources") }}
                    </div>
                    <div class="search-input col-12">
                        <b-col
                            cols="12"
                            sm="9"
                            md="8"
                            lg="10"
                            xl="10"
                            class="div-custom-input input__resources"
                        >
                            <div class="icon-block">
                                <SearchIcon class="search-icon" />
                            </div>
                            <b-form-tags
                                class="input-search-resources"
                                ref="formTagResources"
                                v-model="filter.textFilter"
                                duplicate-tag-text=""
                                :placeholder="
                                    filter.textFilter.length === 0
                                        ? $t('SearchPlaceholderDefault')
                                        : ''
                                "
                                @input="getResources()"
                                remove-on-delete
                                add-on-change
                            />
                        </b-col>
                        <b-col
                            cols="12"
                            sm="3"
                            md="4"
                            lg="2"
                            xl="2"
                            class="pr-1 pr-sm-0 add-resource"
                        >
                            <b-button
                                class="btn-new-resource"
                                v-b-toggle.sidebar-right
                                @click="changeModalName('new')"
                            >
                                <AddIcon class="add-icon" />
                                {{ $t("ResourcePage.NewFeature") }}
                            </b-button>
                        </b-col>
                    </div>
                </div>
                <div class="body-block">
                    <resources-table
                        :list="list"
                        :filter="filter"
                        :typeList="typeList"
                        :prefix="prefix"
                        @edit="(id) => changeModalName('edit', id)"
                        @deletedResource="onDeleteResource(list)"
                        @updatePageNumber="updatePageNumber"
                        @updatepageSize="updatepageSize"
                        @updateFieldAndSort="updateFieldAndSort"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import paperlessAttachments from "@/utils/paperlessAttachments";
    import { mapMutations, mapState } from "vuex";
    import {
        BFormTags,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BFormSelectOption,
        BButton,
        BCol,
        BSidebar,
        VBToggle,
        BCollapse
    } from "bootstrap-vue";
    import Ripple from "vue-ripple-directive";
    import ResourcesTable from "./components/resources-table.vue";
    import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
    import EmptyBoxIcon from "@core/assets/icons/empty-box-icon.svg";
    import UrlIcon from "@core/assets/icons/url-icon.svg";
    import AddIcon from "@core/assets/icons/add-icon.svg";
    import PdfFileIcon from "@core/assets/icons/pdf-file-icon.svg";
    import ImgFileIcon from "@core/assets/icons/img-file-icon.svg";
    import ZipFileIcon from "@core/assets/icons/zip-file-icon.svg";
    import VideoFileIcon from "@core/assets/icons/video-file-icon.svg";
    import TextFileIcon from "@core/assets/icons/text-file-icon.svg";
    import WordFileIcon from "@core/assets/icons/word-file-icon.svg";
    import ExcelFileIcon from "@core/assets/icons/excel-file-icon.svg";
    import GlobalFileIcon from "@core/assets/icons/global-file-icon.svg";
    import CustomFields from "@core/components/customFields/index.vue";
    import {
        handleCreateParametersForPayload,
        processIndustrialParameters,
        handleFillCustomFields
    } from "@/utils/customFields";
    import ToggleCard from "./components/toggle-card.vue";
    import ModalStepByStep from "./components/ModalStepByStep.vue";

    const ICONS = {
        PdfFileIcon,
        ImgFileIcon,
        ZipFileIcon,
        VideoFileIcon,
        TextFileIcon,
        ExcelFileIcon,
        WordFileIcon,
        GlobalFileIcon
    };

    export default {
        mixins: [paperlessAttachments],
        components: {
            BFormTags,
            BButton,
            BCol,
            BSidebar,
            BFormGroup,
            BFormInput,
            BFormSelect,
            BFormSelectOption,
            ResourcesTable,
            ToastificationContent,
            ModalStepByStep,
            BCollapse,
            AddIcon: () => import("@core/assets/icons/add-icon.svg"),
            CloseIcon: () => import("@core/assets/icons/close-icon.svg"),
            SingleSelect: () => import("@core/components/multiselect/SingleSelect.vue"),
            SearchIcon: () => import("@core/assets/icons/search-icon.svg"),
            ArrowDownIcon: () => import("@core/assets/icons/arrow-down.svg"),
            InfoIcon: () => import("@core/assets/icons/info-icon.svg"),
            AttachmentsIcon: () => import("@core/assets/icons/attachments-icon.svg"),
            TrashIcon: () => import("@core/assets/icons/trash-icon.svg"),
            AddIcon,
            VBToggle,
            CustomFields,
            EmptyBoxIcon,
            UrlIcon,
            ToggleCard
        },
        data() {
            return {
                filter: {
                    pageNumber: 1,
                    pageSize: 10,
                    totalItems: 0,
                    sort: "",
                    fieldSort: "",
                    textFilter: []
                },
                newLink: "",
                links: [],
                initialLinks: [],
                attachments: [],
                initialAttachments: [],
                currentStep: 1,
                currentTab: "info",
                isStepBlockOpenned: false,
                automaticFinalization: false,
                allowMultipleOrders: false,
                orderQuantity: 2,
                sidebarVisible: false,
                forceRenderIndustrialParametersList: true,
                modalTitle: "ResourcePage.NewFeature",
                prefix: localStorage.getItem("prefix"),
                noItemsFound: false,
                name: "",
                appointment: 0,
                idleTime: "",
                type: 0,
                code: "",
                customMultipleSelect: 0,
                customSelect: 0,
                customInput: "",
                customNumericInput: 0,
                productionRate: "0.0",
                customFields: [],
                flagNameEqual: false,
                flagCodeEqual: false,
                editById: null,
                states: {
                    name: null,
                    code: null,
                    type: null,
                    productionRate: null,
                    customFieldsForceError: null,
                    idleTime: null,
                    appointment: null,
                    orderQuantity: null,
                    newLink: null
                },
                typeList: [],
                appointmentList: [
                    {
                        value: 1,
                        text: "Manual",
                        name: "Manual",
                        nameEN: "Manual"
                    },
                    {
                        value: 2,
                        text: "Automático",
                        name: "Automático",
                        nameEN: "Automatic"
                    }
                ],
                list: [],
                device:
                    window.innerWidth > 768
                        ? "desktop"
                        : window.innerWidth > 480 && window.innerWidth <= 768
                          ? "tablet"
                          : "mobile"
            };
        },
        directives: {
            "b-toggle": VBToggle,
            Ripple
        },
        created() {
            window.addEventListener("resize", this.handleResize);
        },
        destroyed() {
            window.removeEventListener("resize", this.handleResize);
        },
        async mounted() {
            this.$http2
                .get(`/api/myconfig/resource/context`)
                .then((response) => {
                    this.typeList = response.data.resourceType.map((item) => ({
                        value: item.id,
                        text: item.name
                    }));

                    this.customFields = processIndustrialParameters(
                        response?.data?.industrialParameter
                    );
                })
                .catch((error) => console.error(error));

            await this.getResources();
            if (this.editId) {
                this.sidebarVisible = true;
                this.changeModalName("edit", this.editId);
                this.SET_EDIT_ID(null);
            }
        },
        methods: {
            ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
            ...mapMutations("resource", ["SET_EDIT_ID"]),
            handleResize() {
                this.device =
                    window.innerWidth > 768
                        ? "desktop"
                        : window.innerWidth > 480 && window.innerWidth <= 768
                          ? "tablet"
                          : "mobile";
            },
            getModalTitle(v) {
                if (v === 1) return "PeoplePage.GeneralInformation";
                if (v === 2) return "MaterialsPage.Attachments";
            },
            openStepBlock() {
                this.isStepBlockOpenned = !this.isStepBlockOpenned;
            },
            addNewLink() {
                this.states.newLink = null;
                const link = this.newLink.trim();

                if (!link) return;

                const exists = this.links.some((l) => l.file === link);
                if (exists) {
                    this.states.newLink = false;
                    return;
                }

                this.links.push({
                    file: link,
                    name: link
                });

                this.newLink = "";
            },
            removeLink(index) {
                this.states.newLink = null;
                this.links.splice(index, 1);
            },
            addNewAttachment() {
                this.$refs.editfilesResource.click();
            },
            removeFile(index) {
                this.attachments.splice(index, 1);
            },
            getFileDetails(file) {
                const mimeType = file?.toLowerCase() || "";

                switch (true) {
                    case mimeType.includes("image"):
                        return { fileType: "Image", icon: ICONS.ImgFileIcon };
                    case mimeType.includes("x-zip"):
                        return { fileType: "ZIP", icon: ICONS.ZipFileIcon };
                    case mimeType.includes("pdf"):
                        return { fileType: "PDF", icon: ICONS.PdfFileIcon };
                    case mimeType.includes("video"):
                        return { fileType: "Video", icon: ICONS.VideoFileIcon };
                    case mimeType.includes("spreadsheetml"):
                        return { fileType: "Excel", icon: ICONS.ExcelFileIcon };
                    case mimeType.includes("wordprocessingml"):
                        return { fileType: "Word", icon: ICONS.WordFileIcon };
                    case mimeType.includes("text"):
                        return { fileType: "Text", icon: ICONS.TextFileIcon };
                    default:
                        return { fileType: "Unknown", icon: ICONS.GlobalFileIcon };
                }
            },
            previousStep() {
                this.currentStep = this.currentStep - 1;
            },
            nextStep() {
                this.flagCodeEqual = false;
                this.flagNameEqual = false;
                const isValid = this.fieldsValidate();
                if (!isValid) return;

                if (this.currentStep < 3) {
                    this.currentStep = this.currentStep + 1;
                }
            },
            decimalMask() {
                this.productionRate = this.productionRate.replace(/\D(?=[^\.])+/g, ""); // Remove caracteres não numéricos, exceto ponto decimal
                this.productionRate = this.productionRate.replace(/^0*(\d+)(\d{2})$/, "$1.$2"); // Insere o ponto decimal antes dos 2 últimos dígitos
            },
            onQuantityBlur() {
                let value = parseInt(this.orderQuantity, 10);

                if (isNaN(value) || value < 2) {
                    this.orderQuantity = 2;
                }
            },
            activeCarousel() {
                const vm = this;
                $(function () {
                    document
                        .getElementsByClassName("input-search-resources")[0]
                        .setAttribute("tabIndex", "-1");

                    const slider = document.querySelector(".b-form-tags-list");
                    let mouseDown = false;
                    let startX, scrollLeft;

                    let startDragging = function (e) {
                        mouseDown = true;
                        startX = e.pageX - slider.offsetLeft;
                        scrollLeft = slider.scrollLeft;
                    };
                    let stopDragging = function () {
                        mouseDown = false;
                    };

                    slider.addEventListener("mousemove", (e) => {
                        e.preventDefault();
                        if (!mouseDown) {
                            return;
                        }
                        const x = e.pageX - slider.offsetLeft;
                        const scroll = x - startX;
                        slider.scrollLeft = scrollLeft - scroll;
                    });

                    slider.addEventListener("mousedown", startDragging, false);
                    slider.addEventListener("mouseup", stopDragging, false);
                    slider.addEventListener("mouseleave", stopDragging, false);

                    $(".b-form-tags-input").blur((event) => {
                        let input = vm.$refs.formTagResources;
                        input.addTag(event.target.value);
                    });
                });
            },
            async getResources() {
                this.UPDATE_FLAG_SHOW_OVERLAY(true);

                const textFilterQuery = this.filter.textFilter;

                await this.$http2
                    .get(
                        `/api/myconfig/resource?PageSize=${this.filter.pageSize}&PageNumber=${this.filter.pageNumber}&PageOrder=${this.filter.sort}&PageOrderField=${this.filter.fieldSort}&TextFilter=${textFilterQuery}`
                    )
                    .then((response) => {
                        this.noItemsFound = !!textFilterQuery.length;
                        this.list = response.data.data.resources;
                        this.filter.totalItems = response.data.data.totalItems;
                        this.UPDATE_FLAG_SHOW_OVERLAY(false);
                        this.forceRenderIndustrialParametersValue();
                        this.activeCarousel();
                    });
            },
            getEditResource(id) {
                this.editById = id;
                const resourceSelected = this.list.filter((e) => e.id === id);
                const currentResource = resourceSelected[0];

                this.name = currentResource.name;
                this.code = currentResource.code;
                this.type = currentResource.resourceTypeId;
                this.productionRate = currentResource.productionRate;
                this.appointment = currentResource.appointmentType;
                this.idleTime = currentResource.idleTimeMinutes;
                this.automaticFinalization = currentResource.autoCompleteEnabled;
                this.allowMultipleOrders = currentResource.multipleOrdersEnabled;
                this.orderQuantity = currentResource.maxSimultaneousOrders;
                handleFillCustomFields(this.customFields, currentResource.industrialParameter);
                if (currentResource.attachments) {
                    const localAttachments =
                        currentResource.attachments.map((e) => {
                            const { icon } = this.getFileDetails(e.fileType);
                            return { ...e, icon };
                        }) || [];

                    const files = localAttachments.filter((e) => e.fileType !== "Link");
                    const links = localAttachments.filter((e) => e.fileType === "Link");

                    this.attachments = [...files];
                    this.initialAttachments = [...files];

                    this.links = [...links];
                    this.initialLinks = [...links];
                }
            },
            getFileDetails(file) {
                const mimeType = file?.toLowerCase() || "";

                switch (true) {
                    case mimeType.includes("image"):
                        return { fileType: "Image", icon: ICONS.ImgFileIcon };
                    case mimeType.includes("x-zip"):
                        return { fileType: "ZIP", icon: ICONS.ZipFileIcon };
                    case mimeType.includes("pdf"):
                        return { fileType: "PDF", icon: ICONS.PdfFileIcon };
                    case mimeType.includes("video"):
                        return { fileType: "Video", icon: ICONS.VideoFileIcon };
                    case mimeType.includes("spreadsheetml"):
                        return { fileType: "Excel", icon: ICONS.ExcelFileIcon };
                    case mimeType.includes("wordprocessingml"):
                        return { fileType: "Word", icon: ICONS.WordFileIcon };
                    case mimeType.includes("text"):
                        return { fileType: "Text", icon: ICONS.TextFileIcon };
                    default:
                        return { fileType: "Unknown", icon: ICONS.GlobalFileIcon };
                }
            },
            onDeleteResource(list) {
                if (list.length === 1 && this.filter.pageNumber > 1) {
                    this.updatePageNumber(this.filter.pageNumber - 1);
                } else {
                    this.getResources();
                }
            },
            changeModalName(name, id) {
                if (name === "edit") {
                    this.modalTitle = "ResourcePage.EditFeature";
                    this.getEditResource(id);
                } else {
                    this.modalTitle = "ResourcePage.NewFeature";
                    this.clearFields();
                }
                this.clearValidations();
            },
            forceRenderIndustrialParametersValue() {
                this.forceRenderIndustrialParametersList = false;
                this.$nextTick().then(() => {
                    this.forceRenderIndustrialParametersList = true;
                });
            },
            updatepageSize(value) {
                this.filter.pageSize = value;
            },
            updatePageNumber(value) {
                this.filter.pageNumber = value;
            },
            updateFieldAndSort(e, text) {
                this.filter.sort = this.filter.sort = text;
                this.filter.fieldSort = e;
            },
            clearFields() {
                this.name = "";
                this.code = "";
                this.type = 0;
                this.productionRate = "0.0";
                this.appointment = 0;
                this.idleTime = "";
                this.automaticFinalization = false;
                this.allowMultipleOrders = false;
                this.orderQuantity = 2;
                this.isStepBlockOpenned = false;
                this.currentStep = 1;
                this.customFields.map((e) => (e.value = null));
                this.newLink = "";
                this.links = [];
                this.initialLinks = [];
                this.attachments = [];
                this.initialAttachments = [];
                this.currentStep = 1;
                this.currentTab = "info";
            },
            clearValidations() {
                this.states.name = null;
                this.states.type = null;
                this.states.code = null;
                this.states.appointment = null;
                this.states.idleTime = null;
                this.states.orderQuantity = null;
                this.states.productionRate = null;
                this.states.customFieldsForceError = null;
                this.states.newLink = null;
            },
            fieldsValidate() {
                this.clearValidations();

                const validName = (this.states.name =
                    this.name && this.flagNameEqual === false ? true : false);
                const validType = (this.states.type =
                    this.type != "" && this.type != 0 && this.type !== null);
                const validCode = (this.states.code =
                    this.code && this.flagCodeEqual === false ? true : false);
                const validProductionRate = (this.states.productionRate =
                    Number(this.productionRate) != 0);

                const requiredFields = this.customFields.filter((e) => e.required);
                const isCustomFieldsValid = requiredFields.map((e) => {
                    if (e.required) {
                        return e.value != null && e.value != 0;
                    }
                });
                const validAppointmentType = (this.states.appointment =
                    this.appointment != "" && this.appointment != 0 && this.appointment !== null);
                const validIdleTime = (this.states.idleTime =
                    this.appointment != 2
                        ? null
                        : this.idleTime != "" && this.idleTime !== null && this.idleTime != 0);
                const validNumberOrders = (this.states.orderQuantity = this.allowMultipleOrders
                    ? this.orderQuantity != "" &&
                      this.orderQuantity >= 2 &&
                      this.orderQuantity !== null
                    : null);

                const newFieldsValid =
                    (validAppointmentType === null || validAppointmentType) &&
                    (validIdleTime === null || validIdleTime) &&
                    (validNumberOrders === null || validNumberOrders);

                const hasInvalidFields = isCustomFieldsValid.includes(false);
                hasInvalidFields
                    ? (this.states.customFieldsForceError = true)
                    : (this.states.customFieldsForceError = false);

                return (
                    validName &&
                    validType &&
                    validCode &&
                    validProductionRate &&
                    !hasInvalidFields &&
                    newFieldsValid
                );
            },
            verifyTypeOfResource() {
                return this.modalTitle.includes("NewFeature") ? "new" : "edit";
            },
            showToast(title, icon, text, variant) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: title,
                        icon: icon,
                        text: text,
                        variant
                    }
                });
            },
            async addResource() {
                if (this.uploadingAttachments) return;
                this.flagCodeEqual = false;
                this.flagNameEqual = false;
                const isValid = this.fieldsValidate();
                if (!isValid) return;

                this.UPDATE_FLAG_SHOW_OVERLAY(true);

                let typeOfResource = "";

                typeOfResource = this.verifyTypeOfResource();

                const parameters = handleCreateParametersForPayload(this.customFields);
                const missingAttachmentIds =
                    this.initialAttachments
                        ?.filter(
                            (initialAttachment) =>
                                !this.attachments.some(
                                    (attachment) =>
                                        attachment.id === initialAttachment.id &&
                                        attachment.name === initialAttachment.name
                                )
                        )
                        ?.map((attachment) => attachment.id) || [];

                const missingLinkIds =
                    this.initialLinks
                        .filter(
                            (initialLink) =>
                                !this.links.some(
                                    (link) =>
                                        link.id === initialLink.id && link.name === initialLink.name
                                )
                        )
                        ?.map((link) => link.id) || [];

                const missingIds = [...missingAttachmentIds, ...missingLinkIds];

                const payload = {
                    name: this.name,
                    resourceTypeId: this.type,
                    code: this.code,
                    productionRate: this.productionRate ? Number(this.productionRate) : null,
                    appointmentType: this.appointment,
                    idleTimeMinutes: this.idleTime !== "" ? this.idleTime : 0,
                    autoCompleteEnabled: this.automaticFinalization,
                    multipleOrdersEnabled: this.allowMultipleOrders,
                    maxSimultaneousOrders: this.allowMultipleOrders
                        ? Number(this.orderQuantity)
                        : 1,
                    industrialParameter: parameters,
                    attachments: [
                        ...(this.attachments?.map((e) => ({
                            file: e.file,
                            name: e.name,
                            fileType: e.fileType
                        })) || []),
                        ...(this.links?.map((l) => ({
                            file: l.file,
                            name: l.name,
                            fileType: "Link"
                        })) || [])
                    ],
                    deletedAttachments: missingIds
                };

                if (typeOfResource === "new") {
                    await this.$http2
                        .post(`/api/myconfig/resource`, payload)
                        .then((response) => {
                            this.showToast(
                                this.$t("IntegrationPage.success"),
                                "SmileIcon",
                                this.$t("ResourcePage.ResourceCreated"),
                                "success"
                            );
                            this.getResources();
                            this.$root.$emit("bv::toggle::collapse", "sidebar-right");
                            this.clearFields();
                            this.clearValidations();
                        })
                        .catch((error) => {
                            error.response.data.errors.map((e) => {
                                if (e.id === 3) {
                                    this.currentStep = 1;
                                    this.currentTab = "info";
                                    this.flagNameEqual = true;
                                } else if (e.id === 4) {
                                    this.currentStep = 1;
                                    this.currentTab = "info";
                                    this.flagCodeEqual = true;
                                } else {
                                    this.showToast(
                                        this.$t("IntegrationPage.Error"),
                                        "SmileIcon",
                                        e.message,
                                        "danger"
                                    );
                                }
                            });
                            this.fieldsValidate();
                        })
                        .finally(() => {
                            this.UPDATE_FLAG_SHOW_OVERLAY(false);
                        });
                } else if (typeOfResource === "edit") {
                    await this.$http2
                        .put(`/api/myconfig/resource/${this.editById}`, payload)
                        .then((response) => {
                            this.showToast(
                                this.$t("IntegrationPage.success"),
                                "SmileIcon",
                                this.$t("ResourcePage.SavedChanges"),
                                "success"
                            );
                            this.$root.$emit("bv::toggle::collapse", "sidebar-right");
                            this.clearFields();
                            this.clearValidations();
                        })
                        .catch((error) => {
                            error.response.data.errors.map((e) => {
                                if (e.id === 3) {
                                    this.currentStep = 1;
                                    this.currentTab = "info";
                                    this.flagNameEqual = true;
                                } else if (e.id === 4) {
                                    this.currentStep = 1;
                                    this.currentTab = "info";
                                    this.flagCodeEqual = true;
                                } else {
                                    this.showToast(
                                        this.$t("IntegrationPage.Error"),
                                        "SmileIcon",
                                        e.message,
                                        "danger"
                                    );
                                }
                            });
                            this.fieldsValidate();
                        })
                        .finally(() => {
                            this.UPDATE_FLAG_SHOW_OVERLAY(false);
                            this.getResources();
                        });
                }
            }
        },
        computed: {
            ...mapState("resource", {
                editId: "editId"
            }),
            displayImportantFirst() {
                return this.customFields.sort((a, b) => {
                    if (a.important && !b.important) {
                        return -1;
                    }
                    if (!a.important && b.important) {
                        return 1;
                    }
                    return 0;
                });
            }
        },
        watch: {
            sidebarVisible(v) {
                this.forceRenderIndustrialParametersValue();
                if (!v) this.clearFields();
            },
            "filter.pageNumber"() {
                this.getResources();
            },
            "filter.pageSize"() {
                this.getResources();
            },
            "filter.sort"() {
                this.getResources();
            },
            currentStep(v) {
                if (v === 1) this.currentTab = "info";
                if (v === 2) this.currentTab = "attachments";
            }
        }
    };
</script>
<style lang="scss">
    .sidebar-manage-table {
        .custom-select {
            cursor: pointer;
            padding: 4px 34px 4px 8px;
            background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.17975 3.78813L7.05862 0.855236L7.64775 1.44457L4.00127 5.14393L0.352313 1.44451L0.941458 0.855158L3.823 3.7882L4.00141 3.96981L4.17975 3.78813Z' fill='%23CFC4BE' stroke='%23CFC4BE' stroke-width='0.5'/%3E%3C/svg%3E") !important;

            &[disabled] {
                border-radius: 5px;
                border: 1px solid #7e7570;
                background-color: #eee;
                background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.17975 3.78813L7.05862 0.855236L7.64775 1.44457L4.00127 5.14393L0.352313 1.44451L0.941458 0.855158L3.823 3.7882L4.00141 3.96981L4.17975 3.78813Z' fill='%237E7570' stroke='%237E7570' stroke-width='0.5'/%3E%3C/svg%3E") !important;
                color: #7e7570 !important;
            }
        }

        .b-sidebar-header {
            display: contents;

            .header-sidebar {
                display: flex;
                justify-content: space-between;
                padding: 16px;

                .sidebar-title {
                    display: flex;
                    align-items: center;
                    color: #4c4541;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 600;
                    min-height: 26px;
                }
            }

            .close-icon {
                border: 1px solid #974900;
                border-radius: 5px;
                width: 28px;
                height: 28px;
                display: flex;
                align-items: center;
                justify-content: center;

                svg {
                    width: 12px;
                    height: 12px;

                    path {
                        fill: #974900;
                    }
                }

                &:hover {
                    background-color: #ffede2 !important;
                }

                &:active {
                    background-color: #ffdbc4 !important;
                }
            }

            .separator {
                width: 100%;
                height: 1px;
                background: #cfc4be;
            }
        }

        &.is-edit {
            .b-sidebar-header {
                .header-sidebar {
                    .sidebar-title {
                        font-size: 18px;
                        line-height: 26px; /* 144.444% */
                    }
                }
            }
            .b-sidebar {
                box-shadow: 0px 4px 24px 0px rgba(58, 46, 38, 0.1);
                border-left: none;

                .modal-navbar {
                    display: flex;

                    .info,
                    .times,
                    .attachments {
                        cursor: pointer;
                        width: 100%;
                        text-align: center;
                        color: #998f8a;
                        font-size: 16px;
                        font-weight: 600;
                        padding: 16px 0 14px;
                        border-bottom: 1px solid #cfc4be;

                        &.active {
                            color: #974900;
                            background: #fff;
                            box-shadow: 0px -4px 0px -1px #974900 inset;
                        }
                    }
                }
            }
        }

        .b-sidebar {
            box-shadow: none;
            border-left: 1px solid #cfc4be;
            height: 100% !important;

            .b-sidebar-body {
                padding: 16px 0;

                .links-attachments-tab {
                    .attachments-tab-block {
                        max-height: 394px;
                        overflow: auto;
                    }

                    .links-tab-block {
                        max-height: 340px;
                        overflow: auto;
                        .add-urls-block {
                            display: flex;
                            gap: 10px;

                            .form-group {
                                margin-bottom: 0;
                                position: relative;
                                width: 100%;

                                .form-control.is-invalid,
                                .form-control.is-valid {
                                    background-image: none !important;
                                }
                                .invalid-feedback {
                                    position: absolute !important;
                                }

                                .form-control {
                                    &::placeholder {
                                        color: #cfc4be;
                                    }
                                    &:focus {
                                        border-color: #974900;
                                    }
                                }
                            }
                        }
                    }

                    .links-block,
                    .files-block {
                        padding-top: 16px;
                    }

                    .no-attachments-block,
                    .no-links-block {
                        max-height: 298px;
                        height: 100%;
                        .no-attachments,
                        .no-links {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            border-radius: 6px;
                            margin: 0 16px;
                            max-height: 298px;
                            height: 100%;

                            .empty-box,
                            .no-url-icon {
                                fill: #998f8a;
                                width: 80px;
                                height: 80px;
                            }

                            .title {
                                padding-top: 12px;
                                font-size: 16px;
                                font-weight: 600;
                                line-height: 26px;
                                color: #4c4541;
                                margin: 0;
                            }

                            .btn-new-attachments {
                                border-color: #974900 !important;
                                background-color: #974900 !important;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                gap: 8px;
                                padding: 8px 21px;
                                line-height: 20px;
                                letter-spacing: 0.175px;

                                .add-icon {
                                    width: 14px;
                                    height: 14px;
                                    fill: #fff;
                                }
                            }

                            @media (max-width: 480px) {
                                .empty-box,
                                .no-url-icon {
                                    width: 40px;
                                    height: 40px;
                                }

                                .title {
                                    font-size: 14px;
                                }

                                .subtitle {
                                    font-size: 12px;
                                    text-align: center;
                                    padding: 4px 48px 12px;
                                    line-height: 16px;
                                }

                                .btn-new-attachments {
                                    padding: 3px 14px;
                                    color: #fff;
                                    font-size: 12px;
                                    font-weight: 600;
                                    line-height: 20px;
                                    letter-spacing: 0.15px;

                                    .add-icon {
                                        width: 12px;
                                        height: 12px;
                                    }
                                }
                            }
                        }
                    }

                    .btn-new-link {
                        box-shadow: none;
                        font-weight: 600;
                        font-size: 14px;
                        line-height: 20px;
                        border-radius: 5px;

                        background-color: transparent !important;
                        color: #974900 !important;
                        border: 1px solid #974900 !important;
                        padding: 8px 21px;

                        &:hover {
                            box-shadow: none;
                            background-color: #ffede2 !important;
                        }

                        &:active {
                            background-color: #ffdbc4 !important;
                        }

                        @media (max-width: 480px) {
                            font-size: 12px !important;
                            padding: 3px 21px !important;
                        }
                    }

                    .btn-new-attachment {
                        box-shadow: none;
                        width: 100%;
                        font-weight: 600;
                        font-size: 14px;
                        line-height: 20px;
                        border-radius: 5px;

                        background-color: transparent !important;
                        color: #974900 !important;
                        border: 1px solid #974900 !important;
                        padding: 8px 21px;

                        &:hover {
                            box-shadow: none;
                            background-color: #ffede2 !important;
                        }

                        &:active {
                            background-color: #ffdbc4 !important;
                        }

                        @media (max-width: 480px) {
                            font-size: 12px !important;
                            padding: 3px 21px !important;
                        }
                    }

                    .attached-files,
                    .attached-links {
                        color: #4c4541;
                        font-size: 16px;
                        font-weight: 600;
                        line-height: 26px; /* 162.5% */
                        padding: 0 16px 16px;
                    }

                    .files-block {
                        max-height: 300px;
                        overflow: auto;
                    }

                    .attached-file,
                    .attached-link {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 16px;
                        padding: 23.5px 29px;
                        border-bottom: 1px solid #cfc4be;

                        .icon-name {
                            display: flex;
                            align-items: center;
                            gap: 16px;
                            overflow: hidden;

                            .icon {
                                fill: #4c4541;
                                width: 28px;
                                height: 20px;
                            }

                            .text {
                                color: #998f8a;
                                font-size: 14px;
                                font-weight: 400;
                                max-width: -webkit-fill-available;
                                width: 100%;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                line-height: 20px; /* 142.857% */
                            }
                        }

                        .delete-file,
                        .delete-link {
                            display: flex;
                            width: 28px;
                            height: 28px;
                            border-radius: 5px;
                            cursor: pointer;
                            padding: 8px;

                            &:hover {
                                background-color: #ffede2 !important;
                            }

                            &:active {
                                background-color: #ffdbc4 !important;
                            }
                        }
                    }
                }

                .form-group {
                    .form-control.is-invalid,
                    .form-control.is-valid {
                        background-image: none !important;
                    }

                    .form-control {
                        &::placeholder {
                            color: #cfc4be;
                        }

                        &:focus {
                            border-color: #974900;
                        }
                    }

                    &.appointment {
                        display: flex;
                        gap: 16px;

                        .idle-time .form-group {
                            padding-top: 3px;
                        }
                    }
                }

                .toggle-block {
                    padding: 0 14px;

                    .order-quantity {
                        display: flex;
                        gap: 16px;
                        padding-top: 16px;

                        span {
                            width: 100%;
                            color: #4c4541;
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 20px;
                        }

                        .form-group {
                            width: 100%;
                        }
                    }
                }

                &::-webkit-scrollbar {
                    display: none !important;
                }
            }
        }

        .step-action {
            padding: 16px 0;

            .step-collapse {
                padding-left: 16px;
            }

            .step-collapse,
            .text {
                display: flex;
                gap: 8px;
                color: #4c4541;
                font-size: 16px;
                font-weight: 600;
                line-height: 26px;
                .icon {
                    svg {
                        width: 16px;
                        height: 16px;
                        fill: #974900;
                    }
                }

                &.not-collapsed {
                    svg {
                        transform: rotate(-180deg);
                        transition: all 0.3s;
                    }
                }

                &.collapsed {
                    svg {
                        transform: rotate(0);
                        transition: all 0.3s;
                    }
                }
            }
            .text {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding-right: 16px;
            }

            .step-progress {
                display: flex;
                gap: 4px;
                padding: 4px 16px 0;
                .first-step,
                .second-step,
                .third-step {
                    width: 50%;
                    height: 4px;
                    border-radius: 4px;
                    background: #f4eee8;

                    &.step-active {
                        background: #974900;
                    }

                    &.next-step {
                        background: #66bb6a;
                    }
                }
            }
        }

        .progress-block {
            padding-top: 16px;

            .detail-block {
                padding: 16px 16px 0;

                .info-block,
                .attachments-block,
                .times-block {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    .icon {
                        display: flex;
                        align-items: center;
                        width: 30px;
                        height: 30px;
                        padding: 7px;
                        border-radius: 50%;
                        border: 1px solid #cfc4be;

                        svg {
                            width: 14px;
                            height: 14px;
                            fill: #cfc4be;
                        }
                    }

                    .text {
                        overflow: hidden;
                        color: #cfc4be;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 16px;
                        font-weight: 600;
                        line-height: 26px;
                    }

                    &.step-active {
                        .icon {
                            border-color: #974900;
                            svg {
                                fill: #974900;
                            }
                        }

                        .text {
                            color: #974900;
                        }
                    }

                    &.next-step {
                        .icon {
                            border-color: #66bb6a;
                            background: #66bb6a;
                            svg {
                                fill: #fff;
                            }
                        }

                        .text {
                            color: #66bb6a;
                        }
                    }
                }

                .vertical-separator {
                    margin-left: 14px;
                    width: 1px;
                    height: 16px;
                    background: #cfc4be;

                    &.step-active {
                        background: #974900;
                    }

                    &.next-step {
                        background: #66bb6a;
                    }
                }
            }
        }

        .separator {
            width: 100%;
            height: 1px;
            background: #cfc4be;
        }

        .footer-sidebar {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 16px;

            .buttons,
            .edit-buttons {
                gap: 8px;
            }

            @media (max-width: 480px) {
                justify-content: center;
                .buttons {
                    width: 100%;

                    .btn {
                        width: 50%;
                    }
                }

                .btn-footer {
                    font-size: 12px !important;
                    padding: 3px 21px !important;
                }
            }

            .btn-footer {
                box-shadow: none;
                font-weight: 600;
                font-size: 14px;
                line-height: 20px;
                border-radius: 5px;

                &:hover {
                    box-shadow: none;
                }

                &.btn-cancel {
                    background-color: transparent !important;
                    color: #974900 !important;
                    border: 1px solid transparent !important;
                    padding: 8px 21px;

                    &:hover {
                        background-color: #ffede2 !important;
                    }

                    &:active {
                        background-color: #ffdbc4 !important;
                    }
                }

                &.btn-previous,
                &.btn-cancel.btn-cancel-outline {
                    background-color: transparent !important;
                    color: #974900 !important;
                    border: 1px solid #974900 !important;
                    padding: 8px 21px;

                    &:hover {
                        background-color: #ffede2 !important;
                    }

                    &:active {
                        background-color: #ffdbc4 !important;
                    }
                }

                &.btn-save {
                    border: 1px solid #974900 !important;
                    background-color: #974900 !important;
                    color: #ffff !important;
                    padding: 8px 21px;

                    &:hover {
                        background-color: #9f5714 !important;
                    }

                    &:active {
                        background-color: #a45f1f !important;
                    }
                }
            }
        }
    }

    #resources-page {
        padding: 16px 0;
        border-radius: 6px;
        background: #fff;
        box-shadow: 0px 4px 24px 0px rgba(58, 46, 38, 0.1);

        @media (max-width: 768px) {
            margin-top: 24px;
        }

        &:has(.no-items) {
            height: calc(100vh - 170px);
        }

        .no-items {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-radius: 6px;
            margin: 0 16px;
            border: 1px solid #cfc4be;

            .empty-box {
                width: 80px;
                height: 80px;
            }

            .title {
                font-size: 16px;
                font-weight: 600;
                line-height: 26px;
                color: #4c4541;
                margin: 0;
            }

            .subtitle {
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                color: #998f8a;
                padding: 4px 0 12px;
                margin: 0;
            }

            .btn-new-resource {
                border-color: #974900 !important;
                background-color: #974900 !important;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                padding: 8px 21px;
                line-height: 20px;
                letter-spacing: 0.175px;

                .add-icon {
                    width: 14px;
                    height: 14px;
                    fill: #fff;
                }
            }

            @media (max-width: 480px) {
                .empty-box {
                    width: 40px;
                    height: 40px;
                }

                .title {
                    font-size: 14px;
                }

                .subtitle {
                    font-size: 12px;
                    text-align: center;
                    padding: 4px 48px 12px;
                    line-height: 16px;
                }

                .btn-new-resource {
                    padding: 4px 14px;
                }
            }
        }

        .header-block {
            padding: 0 16px;

            .title {
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
            }

            .search-input {
                display: flex;
                align-items: center;
                padding: 16px 0 8px;

                @media (max-width: 580px) {
                    flex-direction: column;
                    gap: 8px;
                }

                .div-custom-input {
                    display: flex;
                    align-items: center;
                    border-radius: 4px;
                    width: 100%;
                    overflow: hidden;
                    border: 1px solid #cfc4be;

                    .icon-block {
                        display: flex;
                        align-items: center;
                        height: 14px;

                        .search-icon {
                            width: 14px;
                            height: 14px;
                            fill: #cfc4be;
                        }
                    }

                    .input-search-resources {
                        width: 100% !important;
                        border: none;
                        overflow: hidden;

                        &.focus {
                            box-shadow: none;
                        }

                        &.b-form-tags {
                            padding: 0 !important;
                            display: flex;
                            align-items: center !important;

                            .b-form-tags-list {
                                width: 100% !important;
                                margin-left: 14px !important;
                                margin-top: 0;
                                height: 100% !important;
                                flex-wrap: nowrap !important;
                                display: flex !important;
                                align-items: center !important;
                                overflow: scroll;
                                overflow-y: hidden;
                                cursor: grabbing;
                                cursor: -webkit-grabbing;

                                &::-webkit-scrollbar {
                                    display: none !important;
                                }

                                .b-form-tags-field {
                                    margin: 9px 0;
                                }
                            }
                        }

                        .b-form-tags-button {
                            display: none;
                        }

                        .b-form-tag {
                            background-color: #974900;
                            margin-right: 0.6rem;
                            padding: 2px 8px !important;
                            font-size: 13px;
                        }
                    }
                }

                .add-resource {
                    padding-left: 8px !important;
                    padding-right: 0 !important;

                    @media (max-width: 580px) {
                        max-width: 100% !important;
                        padding-left: 0 !important;
                        flex: 0 0 100% !important;
                        width: 100% !important;
                    }

                    .btn-new-resource {
                        border-color: #974900 !important;
                        background-color: #974900 !important;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 8px;
                        width: 100% !important;
                        padding: 8px 0 !important;
                        line-height: 20px;
                        letter-spacing: 0.175px;

                        @media (max-width: 580px) {
                            width: 100%;
                            display: flex;
                            justify-content: center;
                            padding: 3.5px 0 !important;
                        }

                        .add-icon {
                            width: 14px;
                            height: 14px;
                            fill: #fff;
                        }
                    }
                }
            }
        }

        .body-block {
            padding: 0 16px;
            margin: 0 14px;
            overflow-x: auto;

            &::-webkit-scrollbar {
                height: 3px;
            }

            &::-webkit-scrollbar-track {
                background: #fff;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #cfc4be;
                border-radius: 9px;
            }
        }
    }

    @media (max-width: 480px) {
        .b-sidebar {
            width: 100% !important;

            .b-sidebar-body {
                overflow-x: hidden;
            }
        }

        .btn-reset-text {
            display: none;
        }
    }
</style>
